
import { LoggerFactory } from "@/infrastructure/services/logger/logger.factory";
import { ReactNode, useEffect } from "react";

interface ILoggerProviderProps {
    children: ReactNode;
}

export const LoggerProvider: React.FC<ILoggerProviderProps> = ({ children }) => {
    useEffect(() => {
        LoggerFactory.getInstance();
    }, []);
    return children;
}